// client/src/coms/views/chatview_parts/ChatMessageList.js
import React from 'react';
import ChatMessageRow from './ChatMessageRow';

export default function ChatMessageList({
  messagesWithGroupMeta,
  messages,
  filteredMessages,
  loading,
  loadErr,
  membersLoaded,
  messageActionErr,
  messageSearchNorm,
  messageSearch,
  isShellMobile,
  avatarWrapperStyle,
  messagesContentRef,
  editingMessageId,
  editDraft,
  editBusyMessageId,
  deleteBusyMessageId,
  hoveredMessageId,
  setHoveredMessageId,
  setEditDraft,
  beginEditMessage,
  deleteMessage,
  cancelEditMessage,
  saveEditMessage,
  quoteMessage,
  messageActions = [],
  suppressEmptyState = false,
  footerRenderer = null,
}) {
  return (
    <div ref={messagesContentRef}>
      {loadErr ? (
        <div className="coms-msg coms-msg--system">
          <div className="coms-msg-user">system</div>
          <div className="coms-msg-text">Failed to load: {loadErr}</div>
        </div>
      ) : null}

      {messageActionErr ? (
        <div className="coms-msg coms-msg--system">
          <div className="coms-msg-user">system</div>
          <div className="coms-msg-text">Message action failed: {messageActionErr}</div>
        </div>
      ) : null}

      {!suppressEmptyState && !loading && !loadErr && messages.length === 0 ? (
        <div className="coms-msg coms-msg--system">
          <div className="coms-msg-user">system</div>
          <div className="coms-msg-text">No messages yet.</div>
        </div>
      ) : null}

      {!loading && !loadErr && messages.length > 0 && !!messageSearchNorm && filteredMessages.length === 0 ? (
        <div className="coms-msg coms-msg--system">
          <div className="coms-msg-user">system</div>
          <div className="coms-msg-text">No matches for “{messageSearch}”.</div>
        </div>
      ) : null}

      {messagesWithGroupMeta.map((m, i) => (
        <ChatMessageRow
          key={m.id}
          m={m}
          i={i}
          isShellMobile={isShellMobile}
          avatarWrapperStyle={avatarWrapperStyle}
          messagesCount={messagesWithGroupMeta.length}
          editingMessageId={editingMessageId}
          editDraft={editDraft}
          editBusyMessageId={editBusyMessageId}
          deleteBusyMessageId={deleteBusyMessageId}
          hoveredMessageId={hoveredMessageId}
          setHoveredMessageId={setHoveredMessageId}
          setEditDraft={setEditDraft}
          beginEditMessage={beginEditMessage}
          deleteMessage={deleteMessage}
          cancelEditMessage={cancelEditMessage}
          saveEditMessage={saveEditMessage}
          quoteMessage={quoteMessage}
          messageActions={messageActions}
          footerRenderer={footerRenderer}
        />
      ))}
    </div>
  );
}